var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38805",
    "data-name": "Group 38805",
    transform: "translate(-702.397 -3690.301)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_529",
    "data-name": "Ellipse 529",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(702.397 3690.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\uD83D\\uDC4D",
    transform: "translate(742.396 3742.301)",
    fill: "#1c9d87",
    fontSize: 40,
    fontFamily: "AppleColorEmoji, Apple Color Emoji"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20,
    y: 0
  }, "\uD83D\uDC4D")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpIcon);
export default __webpack_public_path__ + "static/media/thumbs-up-icon.d02b585ad78ecc8d7f9be122b6977197.svg";
export { ForwardRef as ReactComponent };